import {TeamTypesEnum} from 'constants/team';
import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {ITeam, Project} from 'types/project';
import {ResponseData} from 'types/response-data';

const storeProjectTeam = api.injectEndpoints({
  endpoints: builder => ({
    storeProjectTeam: builder.mutation<Response, StoreProjectTeamRequest>({
      query: (body: StoreProjectTeamRequest) => {
        return {
          method: 'POST',
          url: `projects/${body.id}/assistants`,
          body,
        };
      },
    }),
  }),
});

interface ITeamRequest {
  user_id: ObjectId;
  type: TeamTypesEnum;
}

export type StoreProjectTeamRequest = {
  id: string | undefined;
  team: ITeamRequest[];
  deleted_records?: ObjectId[];
};

type Response = ResponseData<Array<ITeam>>;

export const {useStoreProjectTeamMutation} = storeProjectTeam;
